export default __webpack_public_path__ + "static/media/9_2.f7bed451.jpg";